import React, { FC } from 'react'
import { ResponseEntityId } from 'types'
import { Button, Modal } from 'UI'
import cl from 'containers/Courses/Table/Modals/ConfirmUnPublish/style.module.scss'
import { ButtonStyles } from 'UI/Button/types'
import { ModalHeight } from 'UI/Modal/types'
import { useNavigate } from 'react-router-dom'

interface CourseOverModalProps {
	onClose: () => void
	isOpen: boolean
	courseId: ResponseEntityId
}

const CourseOverModal: FC<CourseOverModalProps> = ({
	courseId,
	isOpen,
	onClose
}) => {
	const navigate = useNavigate()
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			styleTypes={[ModalHeight.SMALL]}
			title="Проверьте настройки курса"
			description="Курс завершен, для изменения даты завершения курса, перейдите в настройки курса"
		>
			<div className={cl.buttonsContainer}>
				<Button
					onClick={onClose}
					styleTypes={[ButtonStyles.DECLINE_PRIMARY, ButtonStyles.ROUND]}
				>
					Отмена
				</Button>
				<Button
					onClick={() => navigate(`/course/edit/${courseId}`)}
					styleTypes={[ButtonStyles.PRIMARY, ButtonStyles.ROUND]}
				>
					Редактировать курс
				</Button>
			</div>
		</Modal>
	)
}

export default CourseOverModal
